export enum SourcePayRazrApplication {
	Unknown = 0,
	VirtualTerminal = 1,
	ConsumerPortal = 2,
	Api = 3,
	FileImport = 6,
	CardPresent = 7
}
